"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Invitation = void 0;
var Invitation = /** @class */ (function () {
    function Invitation() {
    }
    return Invitation;
}());
exports.Invitation = Invitation;
//# sourceMappingURL=Invitation.js.map